export function TermsOfExchangePage() {
  return (
    <>
      <header className="nk-header" id="home">
        <div className="section section-lg section-b-0">
          <div className="section-heading">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-7 col-lg-9">
                  <div className="position-relative text-center">
                    <h2 className="title text-gradient-heading fw-semibold display-6 mb-4">
                      Exchange of Data Processing Services and Data Transfer
                    </h2>
                    <p className="fs-8">
                      How you can switch away from Yapamar or transfer your data
                      and digital assets, and the obligations of each party.
                    </p>
                    <p className="fs-10 text-muted fw-semibold">
                      Last updated: October 14, 2026
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <main className="nk-main">
        <div className="section section-xl section-t-0">
          <div className="section-content">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-8">
                  <div className="nk-entry">
                    <h5>1. General</h5>
                    <p>
                      Customer has the right, by written notice (
                      <strong>Switching Notice</strong>), to switch from the
                      data processing services provided by Yapamar to the data
                      processing services of another service provider or to
                      transfer all transferable data and digital assets
                      described in Section 2 to ICT infrastructure located in
                      Customer’s own premises (jointly{' '}
                      <strong>Data Transfer</strong>). As Yapamar data
                      processing services are cloud services and are based on
                      its or third parties’ intellectual property rights, the
                      parties acknowledge that the applications described in
                      Regulation (EU) 2023/2854 (<strong>Data Act</strong>) will
                      not be transferred as part of the Data Transfer, unless
                      otherwise agreed or required by mandatory legislation.
                    </p>

                    <h5>2. Subject of Data Transfer</h5>
                    <p>
                      The list of data and digital assets subject to the Data
                      Transfer (<strong>Transferable Data</strong>) is available
                      at{' '}
                      <a
                        href="https://yapamar.com/transferable-data"
                        target="_blank"
                        rel="noopener noreferrer">
                        https://yapamar.com/transferable-data
                      </a>
                      . The following categories of data, which are Yapamar
                      trade secrets, are not included in the Transferable Data:
                      list available at{' '}
                      <a
                        href="https://yapamar.com/excluded-data"
                        target="_blank"
                        rel="noopener noreferrer">
                        https://yapamar.com/excluded-data
                      </a>
                      .
                    </p>

                    <h5>3. Notice Period</h5>
                    <p>
                      A 2-month notice period (<strong>Notice Period</strong>)
                      shall commence upon Customer’s submission of a Switching
                      Notice. If Customer has only given notice of termination,
                      Customer may also give a Switching Notice during the
                      Notice Period, but this will not extend the original
                      Notice Period.
                    </p>

                    <h5>4. Customer’s Obligations</h5>
                    <ul>
                      <li>
                        Customer undertakes to take all reasonable measures to
                        ensure the effective Data Transfer and is responsible
                        for its own actions and the accuracy of the information
                        it provides. Customer is responsible for the use and
                        suitability of the Transferable Data for its own
                        business purposes or those of third parties authorised
                        by it.
                      </li>
                      <li>
                        In the Switching Notice, Customer may notify of its
                        intention to carry out one or more of the following
                        actions with Yapamar assistance after the Notice Period
                        has expired: (a) switch to another data processing
                        service provider, in which case Customer must provide
                        Yapamar with all necessary information about the new
                        service provider and other required information; (b)
                        carry out the Data Transfer described in Section 1 to
                        its own ICT infrastructure located at its premises; or
                        (c) delete the Transferable Data.
                      </li>
                    </ul>

                    <h5>5. Yapamar Obligations</h5>
                    <ul>
                      <li>
                        Yapamar shall commence the Data Transfer without undue
                        delay after receiving Customer’s Switching Notice and
                        shall complete the Data Transfer within 30 days of the
                        end of the Notice Period (
                        <strong>Transition Period</strong>). If the Data
                        Transfer cannot be carried out during the Transition
                        Period for technical reasons, Yapamar shall notify
                        Customer of an alternative transition period within 14
                        days of the Switching Notice. Without limiting Yapamar
                        right to extend the Transition Period, Customer shall
                        have a one-time right to extend the Transition Period so
                        that its total duration does not exceed 7 months.
                      </li>
                      <li>
                        During the Notice Period, Yapamar shall: (a) provide
                        Customer or third parties authorised by Customer with
                        reasonable assistance in the Data Transfer; (b) exercise
                        due care to maintain business continuity and continue to
                        provide the relevant functions or services in accordance
                        with the Agreement; (c) provide clear information on
                        known risks regarding the continuity of its functions or
                        the provision of its services; and (d) ensure that
                        security is maintained during the Data Transfer, with
                        particular regard to the ongoing security of the data
                        during the Retrieval Period as defined in Section 6 in
                        accordance with applicable law. Yapamar data security
                        practices shall be followed.
                      </li>
                      <li>
                        Yapamar shall support Customer’s exit strategy from the
                        services and provide Customer with the information
                        reasonably necessary for planning and implementing the
                        exit.
                      </li>
                      <li>
                        After the Data Transfer, Yapamar shall not be
                        responsible for the integrity of the data or for
                        Customer or a third party authorised by Customer being
                        able to utilise the Transferable Data after the
                        transfer.
                      </li>
                    </ul>

                    <h5>6. Retrieval Period</h5>
                    <p>
                      Yapamar shall keep the Transferable Data available for
                      retrieval by Customer for 30 days after the end of the
                      Transition Period (<strong>Retrieval Period</strong>).
                    </p>

                    <h5>7. Deletion of Transferable Data</h5>
                    <p>
                      Yapamar shall delete all Transferable Data from its own
                      systems and backups at the end of the Retrieval Period or,
                      if the parties have agreed in advance on a longer
                      Retrieval Period, at the end of this extended Retrieval
                      Period, provided that the Data Transfer has been
                      successfully completed. However, Yapamar shall not delete
                      data that cannot be deleted under applicable law or that
                      has not been generated as a result of Customer’s use of
                      the service (e.g. statistics).
                    </p>

                    <h5>8. Termination</h5>
                    <p>
                      The Agreement shall be deemed terminated when termination
                      has taken effect, provided that (a) the Data Transfer has
                      been successfully completed; or (b) upon expiry of the
                      Notice Period, if Customer wishes to delete the
                      Transferable Data in accordance with section 4.2 (c)
                      above. Customer will be notified in writing of the
                      termination of the Agreement. The Data Transfer is
                      considered to have been successfully completed when
                      Customer so informs Yapamar, Yapamar has verifiably
                      completed it, or, in any case, when the Retrieval Period
                      has ended. Notwithstanding the aforesaid, access to the
                      services shall cease in accordance with the Agreement.
                    </p>

                    <h5>9. Provision of Information</h5>
                    <p>
                      Yapamar publishes the information required under Article
                      28(1) of the Data Act at{' '}
                      <a
                        href="https://yapamar.com/data-act"
                        target="_blank"
                        rel="noopener noreferrer">
                        https://yapamar.com/data-act
                      </a>
                      . This includes the information required by the
                      transparency obligation concerning international access
                      and transfers relating to jurisdictions, as well as an
                      overview of data security measures.
                    </p>

                    <h5>10. Transfer Fees</h5>
                    <p>Yapamar does not charge for Data Transfers.</p>

                    <h5>11. Contact</h5>
                    <p>Yapamar OÜ</p>
                    <p className="d-flex align-items-center gap-2 mb-1">
                      <em className="icon ni ni-mail" />
                      <a href="mailto:support@yapamar.com">
                        support@yapamar.com
                      </a>
                    </p>
                    <p className="d-flex align-items-center gap-2">
                      <em className="icon ni ni-map-pin" />
                      Sepapaja 6, Tallinn 15551, Estonia
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
